var map = {
	"./account.svg": "ecec",
	"./add.svg": "76a4",
	"./chevron-back-outline.svg": "2bd7",
	"./chevron-down.svg": "1755",
	"./chevron-forward.svg": "881b",
	"./chevron-up.svg": "bb5d",
	"./close-outline.svg": "6b83",
	"./eye-outline.svg": "9b44",
	"./grapes.svg": "fce8",
	"./heart-outline.svg": "dbac",
	"./heart.svg": "7d16",
	"./invoices.svg": "3ac5",
	"./logout.svg": "69e3",
	"./ordered-before.svg": "eae1",
	"./orders.svg": "3ca5",
	"./reload-outline.svg": "582b",
	"./remove.svg": "5088",
	"./search-outline.svg": "3f96",
	"./winkelmand_empty.svg": "5da6",
	"./winkelmand_filled.svg": "5c62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";